/* Still Soft — product page urgency counters.

   Both numbers here are generated, not measured. Shopify Basic has no way to
   report real concurrent viewers without a server, and the low stock figure is
   a chosen range rather than the real count.

   Two rules this file follows so the numbers at least behave plausibly:

   1. The value is stable for the visit. A scarcity number that rerolls on every
      refresh is the single fastest way to be caught, and being caught costs more
      than the counter earns. Values are stored per product in sessionStorage.
   2. The stock number never claims more than actually exists. Showing "6 left"
      on a size with 2 in stock produces a failed checkout, which is worse than
      showing nothing at all.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-ss-urgency]');
  if (!root) return;

  var pid = root.getAttribute('data-product-id') || 'p';

  var variants = [];
  var form = document.querySelector('[data-ss-cod]');
  if (form) {
    try {
      variants = (JSON.parse(form.getAttribute('data-ss-cod')) || {}).variants || [];
    } catch (e) {
      variants = [];
    }
  }

  function attr(name, fallback) {
    var n = parseInt(root.getAttribute(name), 10);
    return isNaN(n) ? fallback : n;
  }

  function randInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function storageKey(name) {
    return 'ss-urg-' + pid + '-' + name;
  }

  /* Read a value fixed earlier in this session, or make and keep a new one. */
  function stable(name, make) {
    var key = storageKey(name);
    try {
      var saved = sessionStorage.getItem(key);
      if (saved !== null && saved !== '') {
        var parsed = parseInt(saved, 10);
        if (!isNaN(parsed)) return parsed;
      }
    } catch (e) {
      /* private mode, fall through and just generate */
    }
    var made = make();
    try {
      sessionStorage.setItem(key, String(made));
    } catch (e) {}
    return made;
  }

  /* ---------- Low stock ---------- */

  var stockEl = root.querySelector('[data-ss-stock]');
  if (stockEl) {
    var sMin = attr('data-stock-min', 3);
    var sMax = attr('data-stock-max', 7);
    if (sMax < sMin) sMax = sMin;

    var claimed = stable('stock', function () {
      return randInt(sMin, sMax);
    });

    var stockOut = stockEl.querySelector('[data-ss-stock-n]');

    /* Resolve the selected variant from the same JSON the order form reads,
       rather than coupling to the order form's internals. */
    function selectedVariant() {
      var chosen = [];
      var radios = document.querySelectorAll('[data-ss-option]:checked');
      for (var i = 0; i < radios.length; i++) chosen.push(radios[i].value);
      if (!chosen.length) return variants[0] || null;

      for (var v = 0; v < variants.length; v++) {
        var opts = variants[v].options || [];
        var match = true;
        for (var o = 0; o < chosen.length; o++) {
          if (opts[o] !== chosen[o]) {
            match = false;
            break;
          }
        }
        if (match) return variants[v];
      }
      return null;
    }

    function renderStock() {
      var variant = selectedVariant();

      if (!variant || variant.available === false) {
        stockEl.hidden = true;
        return;
      }

      var n = claimed;
      if (typeof variant.inventory === 'number' && variant.inventory >= 0 && variant.inventory < n) {
        n = variant.inventory;
      }

      if (n <= 0) {
        stockEl.hidden = true;
        return;
      }

      stockOut.textContent = String(n);
      stockEl.hidden = false;
    }

    renderStock();

    document.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-ss-option')) {
        renderStock();
      }
    });
  }

  /* ---------- People viewing ---------- */

  var viewEl = root.querySelector('[data-ss-viewers]');
  if (viewEl) {
    var vMin = attr('data-viewers-min', 13);
    var vMax = attr('data-viewers-max', 82);
    if (vMax < vMin) vMax = vMin;

    var count = stable('viewers', function () {
      return randInt(vMin, vMax);
    });
    if (count < vMin) count = vMin;
    if (count > vMax) count = vMax;

    var viewOut = viewEl.querySelector('[data-ss-viewers-n]');
    viewOut.textContent = String(count);
    viewEl.hidden = false;

    /* Drift a step or two at a time. Frozen reads as decoration, and jumping
       forty at a time reads as invented. Deliberately not announced to screen
       readers: a number that changes on a timer would interrupt constantly. */
    setInterval(function () {
      count = Math.min(vMax, Math.max(vMin, count + randInt(-2, 2)));
      viewOut.textContent = String(count);
      try {
        sessionStorage.setItem(storageKey('viewers'), String(count));
      } catch (e) {}
    }, 9000 + randInt(0, 6000));
  }
})();
